import React from 'react';

import Button from '../../components/Button';
import { MessagesProvider, Message } from '../Internationalization';

import messages from './messages';

// There is no element with id="main" on page, so this is useless.

const SkipToContentButton = () => (
  <MessagesProvider messages={messages}>
    <Button id="skip-link" href="#main" className="link">
      <Message id="label" />
    </Button>
  </MessagesProvider>
);

export default SkipToContentButton;



// WEBPACK FOOTER //
// ./src/modules/SkipToContentButton/index.js